module.exports = __webpack_public_path__ + "static/media/portfolio5.5962f374.webp";